(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const menuLists = document.querySelectorAll('[data-menu-id]');
    const headerVariants = document.querySelectorAll('[data-header-brand-link]');

    const DEFAULT_BRAND_ID = document.body?.dataset?.defaultBrand?.trim() || 'sabo';
    const PAGE_BRAND = document.body?.dataset?.pageBrand?.trim();
    const secondaryZacoEnabled = document.body?.dataset?.enableZacoBrand !== 'false';
    const ZACO_ID = 'zaco';
    const prefersReducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getAvailableBrandIds = () => {
      const ids = new Set();
      menuLists.forEach(node => {
        const id = node.dataset.menuId?.trim();
        if (id) ids.add(id);
      });
      headerVariants.forEach(node => {
        const id = node.dataset.sourceMenuId?.trim();
        if (id) ids.add(id);
      });
      if (!secondaryZacoEnabled) {
        ids.delete(ZACO_ID);
      }
      return ids;
    };

    const applyA11yState = (activeId) => {
      headerVariants.forEach(header => {
        const isActive = header.dataset.sourceMenuId?.trim() === activeId;
        header.classList.toggle('active', !!isActive);
        header.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        header.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (header.getAttribute('role') === 'tab') {
          header.setAttribute('tabindex', isActive ? '0' : '-1');
        }
        if (!header.hasAttribute('role')) header.setAttribute('role', 'tab');
        if (!header.hasAttribute('tabindex')) header.setAttribute('tabindex', '0');
      });
      try {
        document.body.dataset.activeBrand = activeId;
        document.body.classList.remove('brand-sabo', 'brand-zaco');
        if (activeId === ZACO_ID) {
          document.body.classList.add('brand-zaco');
        } else {
          document.body.classList.add('brand-sabo');
        }
        document.dispatchEvent(new CustomEvent('brand:changed', { detail: { brand: activeId } }));
        const announcers = document.querySelectorAll('[data-brand-announcer]');
        announcers.forEach(a => a.textContent = `Brand set to ${activeId}`);
      } catch { }
    };

    const pickDefaultBrand = (availableIds) => {
      if (availableIds.has(DEFAULT_BRAND_ID)) return DEFAULT_BRAND_ID;
      // fallback: first available id from menus or variants
      const first = [...availableIds][0];
      return first ?? DEFAULT_BRAND_ID;
    };

    const initFromUrl = (availableIds) => {
      try {
        const url = new URL(window.location.href);
        const urlBrand = url.searchParams.get('brand')?.trim();
        if (urlBrand && availableIds.has(urlBrand)) {
          localStorage.setItem('headerMenuId', urlBrand);
          // Clean the URL param but preserve other params
          url.searchParams.delete('brand');
          history.replaceState({}, '', url.toString());
        }
      } catch (_) {
        /* noop */
      }
    };

    const isLogoImagePane = (node) =>
      Boolean(node?.matches?.('.header-logo__image-container[data-menu-id]'));

    const setMenuVisibility = (headerMenuId) => {
      const activeId = headerMenuId?.trim().toLowerCase();
      menuLists.forEach(menuList => {
        const id = menuList.dataset.menuId?.trim().toLowerCase();
        const inactive = id !== activeId;
        if (isLogoImagePane(menuList)) {
          menuList.classList.remove('hidden');
          menuList.classList.toggle('header-logo__pane--inactive', inactive);
        } else {
          menuList.classList.toggle('hidden', inactive);
        }
      });
      // Drill stacks may be hoisted to .menu-drawer__navigation (see nav-drawer-row-behaviors.js).
      document.querySelectorAll('[data-nav-drill-stack][data-nav-drill-menu-id]').forEach((node) => {
        const id = node.dataset.navDrillMenuId?.trim().toLowerCase();
        if (!id) return;
        const inactive = id !== activeId;
        node.classList.toggle('hidden', inactive);
        if (inactive) node.setAttribute('hidden', '');
        else node.removeAttribute('hidden');
      });
    };

    const updateHeaderLogoAndMenuVariant = () => {
      if (!menuLists) return;

      let headerMenuId = localStorage.getItem('headerMenuId')?.trim();
      const availableIds = getAvailableBrandIds();

      if (!secondaryZacoEnabled) {
        headerMenuId = 'sabo';
        try {
          localStorage.setItem('headerMenuId', 'sabo');
        } catch {
          /* noop */
        }
      } else if (!headerMenuId || !availableIds.has(headerMenuId)) {
        headerMenuId = pickDefaultBrand(availableIds);
        localStorage.setItem('headerMenuId', headerMenuId);
      }

      applyA11yState(headerMenuId);
      setMenuVisibility(headerMenuId);
    };

    const runBrandSwitchUpdate = () => {
      if (
        !PAGE_BRAND &&
        !prefersReducedMotion &&
        typeof document.startViewTransition === 'function'
      ) {
        try {
          document.startViewTransition(() => {
            updateHeaderLogoAndMenuVariant();
          });
          return;
        } catch {
          /* fall through */
        }
      }
      updateHeaderLogoAndMenuVariant();
    };

    // Initialize from URL param first (e.g., ?brand=zaco)
    initFromUrl(getAvailableBrandIds());

    // If page is brand-locked, force the brand and persist it
    if (PAGE_BRAND) {
      try {
        localStorage.setItem('headerMenuId', PAGE_BRAND);
      } catch {}
    }
    updateHeaderLogoAndMenuVariant();

    document.addEventListener('click', (event) => {
      const header = event.target.closest('[data-header-brand-link]');
      if (!header) return;
      const { sourceMenuId } = header.dataset;
      const headerMenuId = sourceMenuId?.trim();

      if (headerMenuId) {
        try { localStorage.setItem('headerMenuId', headerMenuId); } catch {}

        // On brand-locked pages, navigate to the destination brand's homepage
        if (PAGE_BRAND && headerMenuId !== PAGE_BRAND) {
          try {
            const url = new URL('/', window.location.origin);
            url.searchParams.set('brand', headerMenuId);
            window.location.assign(url.toString());
            return;
          } catch {}
        }

        // Neutral pages: switch in place (smooth when View Transitions are supported)
        runBrandSwitchUpdate();
      }
    });

    // Keyboard support for triggers
    document.addEventListener('keydown', (event) => {
      const header = event.target.closest?.('[data-header-brand-link]');
      if (!header) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        header.click();
      }
    });

    document.addEventListener('cart:update', () => setTimeout(updateHeaderLogoAndMenuVariant, 100));
  });
})();
